import { useState, useEffect } from 'react';
import { auth } from "../../firebase/firebase";
import { useNavigate } from 'react-router'
import { useAuth } from '../../contexts/authContext';
import { Typography } from '@mui/material';

interface SuccessDisplayProps {
  sessionId: string
}

const RedirectToArgos = () => {

  return (
    <section>
      <div className="product Box-root">
        <Typography variant="h4">
          Welcome back to Argos
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          We are redirecting you to the main page
        </Typography>
      </div>
    </section>
  );
};

const SuccessDisplay = ({ sessionId }: SuccessDisplayProps) => {
  return (
    <section>
      <div className="product Box-root">
        <Typography variant="h4">
          Subscription to Argos Pro plan successful!
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          We are redirecting you to the Portfolio area...
        </Typography>
      </div>
    </section>
  );
};

interface MessageProps {
  message: string
}

interface ApiCustomerResponse {
  id: string
}

const Message = ({ message }: MessageProps) => (
  <section>
    <p>{message}</p>
  </section>
);

interface SubscriptionPageProps {
  setSelectedValue: (newValue: number) => void
}

export default function SubscriptionPage({ setSelectedValue } : SubscriptionPageProps ) {
  let [message, setMessage] = useState('');
  let [success, setSuccess] = useState(false);
  let [sessionId, setSessionId] = useState('');

  const navigate = useNavigate();

  const { isPaidIndividualCustomer } = useAuth()

  useEffect(() => {
    console.log("Trying to render the subscribe page")

    async function handleSessionResponse() {
      // Check to see if this is a redirect back from Checkout
      const query = new URLSearchParams(window.location.search);

      if (query.get('success')) {
        if (isPaidIndividualCustomer) {          
          setSelectedValue(3)
        } else {          
          let authToken = await auth.currentUser?.getIdToken(true)
          let sessionId = query.get('session_id')
          if (sessionId !== null) {            
            setSuccess(true);
            setSessionId(sessionId);

            fetch('https://www.scitility.com/payment/api/v1/retrieve-customer?session_id=' + sessionId, {
              method: 'GET',
              headers: (authToken) ? {
                'content-type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + authToken
              } : {
                'content-type': 'application/json;charset=UTF-8'
              }
            })
              .then((response) => response.json())
              .then((data: ApiCustomerResponse) => {                

                fetch('https://www.scitility.com/account/api/v1/customer', {
                  method: 'POST',
                  headers: (authToken) ? {
                    'content-type': 'application/json;charset=UTF-8',
                    'Authorization': 'Bearer ' + authToken
                  } : {
                    'content-type': 'application/json;charset=UTF-8'
                  },
                  body: JSON.stringify({ stripeCustomerId: data.id })
                }).then((response) => {
                  if (response.ok) {
                    console.log("Customer stored!")
                    auth.currentUser?.reload()
                    navigate(0)
                  } else {
                    console.log("Got an error " + response)
                  }
                }
                )
              }
              )

          } else {
            setSuccess(false);
            let dateTime = new Date()
            setMessage(
              "Unable to handle your payment. Please contact us at hello@scitility.com with reference: " +
              dateTime + "-uuid-" // TODO: Get user ID 
            );
          }

          // retrieve customer id
          // store customer id against this firebase user

        }
      }

      if (query.get('canceled')) {
        setSuccess(false);
        setMessage(
          "Order canceled -- continue to shop around and checkout when you're ready."
        );
      }

      if (!query.get('success') && !query.get('canceled')) {
        console.log("Handling normal callback")
        navigate("/argos")
      }

    }

    handleSessionResponse()

  }, [sessionId]);

  if (!success && message === '') {
    return <RedirectToArgos />
  } else if (success && sessionId !== '') {
    return <SuccessDisplay sessionId={sessionId} />;
  } else {
    return <Message message={message} />;
  }
}